import { VFC } from 'react';
import classNames from 'classnames';
import { useTextOverflow } from '../common/useTextOverflow';
import './index.scss';

interface IProps {
  title: string;
  line?: number;
  className?: string;
  posterId: number;
}
const POSTER_2_ID = 2;
const PosterTitle: VFC<IProps> = ({ title, line, className, posterId }) => {
  const { containerRef, textsRef, textDoms } = useTextOverflow(title, posterId);
  // 海报2标题要特殊处理
  const isPoster2 = posterId === POSTER_2_ID;
  return (
    <div
      className={classNames('poster-title', `line-${line}`, className)}
      ref={isPoster2 ? null : containerRef}
    >
      <span className="poster-title-text" ref={isPoster2 ? containerRef : textsRef}>
        {isPoster2 ? (
          <span className="poster-title-text-value" ref={isPoster2 ? textsRef : null}>
            {textDoms}
          </span>
        ) : (
          textDoms
        )}
      </span>
      {isPoster2 && <span className="poster-title-decoration"></span>}
    </div>
  );
};

export default PosterTitle;
